export default "__VITE_ASSET__f609a679__"